import script from "./contact.vue?vue&type=script&setup=true&lang=js"
export * from "./contact.vue?vue&type=script&setup=true&lang=js"

import "./contact.vue?vue&type=style&index=0&id=f65090e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f65090e8"]])

export default __exports__